import BaseService from "@/services/BaseService";
import Admin from "@/types/Admin";

export default class AuthService extends BaseService {
    static async auth() {
        return await this.perform<Admin>({
            url: "/portal/auth",
            method: "GET",
            auth: true
        });
    }

    static async login(username: string, password: string) {
        return await this.perform<Admin>({
            url: "/portal/auth",
            method: "POST",
            auth: true,
            body: {
                username: username,
                password: password
            }
        });
    }
}